// extracted by mini-css-extract-plugin
export default {"avatar":"RegisterForm_avatar__5LG3U"};